// DEV-ONLY: a mockup of a Feed that feels alive. Everything that happens on it is made up and runs by itself.
// Open http://localhost:3000/?feedAlive  (never active in a production build)
import React, { useEffect, useRef, useState } from 'react';
import BetLike from '../components/BetLike';
import { TeamAvatar } from '../components/pools/poolFx';

const STEP_MS = 14000;       // something big happens this often
const CHATTER_MS = 7000;    // a friend's flame comes in this often
const GOAL_MS = 2600;
const WIN_MS = 4000;
const NEW_KEPT = 3;         // new posts replace each other, so the mix underneath stays on the page
const ROWS_SHOWN = 3;

const logo = (a) => `https://assets.nhle.com/logos/nhl/svg/${a}_light.svg`;
const money = (n) => `$${(+n).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const pickOne = (list) => list[Math.floor(Math.random() * list.length)];

const TEAMS = {
  SEA: { name: 'Seattle', color: '#00727f' }, CGY: { name: 'Calgary', color: '#C8102E' },
  VGK: { name: 'Vegas', color: '#333f48' }, MTL: { name: 'Montréal', color: '#AF1E2D' }, BOS: { name: 'Boston', color: '#b8860b' },
  FLA: { name: 'Florida', color: '#C8102E' }, WPG: { name: 'Winnipeg', color: '#041E42' },
};
const START_GAMES = {
  a: { away: 'SEA', home: 'CGY', as: 1, hs: 2, period: '2nd', secs: 754 },
  b: { away: 'BOS', home: 'MTL', as: 2, hs: 2, period: '3rd', secs: 312 },
};

let nextId = 1;
const makeBet = (game, team, pick, stake, odds) => ({ id: nextId++, game, team, pick, stake, odds, likes: 0, liked: false, result: null, floats: [] });
// a real night's mix: every kind of moment gets its own shape. Only games 'a' and 'b' are live
const bets13 = () => [
  makeBet('b', 'MTL', 'Montréal to win', 1000, 2.15), makeBet('Florida vs Winnipeg', 'WPG', 'Winnipeg +1.5', 1000, 3.31), makeBet('Vegas vs New Jersey', 'VGK', 'Vegas -1.5', 1000, 2.6),
  makeBet('Toronto vs Ottawa', 'TOR', 'Toronto to win', 800, 1.95), makeBet('Toronto vs Ottawa', 'OTT', 'Ottawa +1.5', 800, 1.8), makeBet('Edmonton vs Vancouver', 'EDM', 'Edmonton -1.5', 700, 2.75),
  makeBet('Edmonton vs Vancouver', 'VAN', 'Vancouver +1.5', 700, 1.7), makeBet('Florida vs Winnipeg', 'FLA', 'Florida to win', 600, 1.85), makeBet('Vegas vs New Jersey', 'NJD', 'New Jersey to win', 500, 3.72),
  makeBet('a', 'CGY', 'Calgary to win', 500, 1.8), makeBet('a', 'SEA', 'Seattle +1.5', 500, 2.6), makeBet('b', 'BOS', 'Boston +1.5', 400, 1.9), makeBet('Toronto vs Ottawa', 'TOR', 'Toronto -1.5', 400, 2.9),
];
const startPosts = () => [
  { id: nextId++, kind: 'boost', bets: [] },
  { id: nextId++, kind: 'bigwin', user: 'Chungussifu', ago: '5 min', amount: 4500, pick: 'Montréal to win', how: '$1,500.00 @ 3.00', team: 'MTL', bets: [] },
  { id: nextId++, user: 'DI4N3', ago: '9 min', bets: [makeBet('a', 'SEA', 'Seattle +1.5', 40, 2.6)] },
  { id: nextId++, user: 'CL34RY', ago: '20 min', bets: bets13() },
  { id: nextId++, kind: 'predict', user: 'Marc88', ago: '1 h', amount: 125, bets: [] },
  { id: nextId++, kind: 'lost', user: 'Chungussifu', ago: '1 h', amount: 500, pick: 'Boston to win', team: 'BOS', bets: [] },
  { id: nextId++, kind: 'rail', bets: [] },
  { id: nextId++, user: 'Marc88', ago: '2 h', bets: [makeBet('Vegas vs New Jersey', 'NJD', 'New Jersey to win', 120, 3.72), makeBet('Edmonton vs Vancouver', 'EDM', 'Edmonton to win', 60, 1.65)] },
  { id: nextId++, kind: 'spin', user: 'DI4N3', ago: '3 h', amount: 300, bets: [] },
  { id: nextId++, kind: 'win', user: 'Marc88', ago: '3 h', amount: 55.8, pick: 'Vegas to win', how: '$15.00 @ 3.72', team: 'VGK', bets: [] },
  { id: nextId++, user: 'Chungussifu', ago: '4 h', bets: [makeBet('Toronto vs Ottawa', 'TOR', 'Toronto to win', 75, 2.05)] },
  { id: nextId++, kind: 'jackpot', user: 'CL34RY', ago: '6 h', amount: 2500, bets: [] },
];
// what drops in, in turn: never the same kind twice in a row
const NEW_POSTS = [
  () => ({ user: 'Chungussifu', bets: [makeBet('Florida vs Winnipeg', 'WPG', 'Winnipeg to win', 300, 2.2)] }),
  () => ({ kind: 'win', user: 'DI4N3', ago: 'just now', amount: 96, pick: 'Vegas to win', how: '$40.00 @ 2.40', team: 'VGK', bets: [] }),
  () => ({ kind: 'lost', user: 'Marc88', ago: 'just now', amount: 120, pick: 'Vancouver +1.5', team: 'VAN', bets: [] }),
  () => ({ user: 'DI4N3', bets: [makeBet('Toronto vs Ottawa', 'TOR', 'Toronto -1.5', 60, 2.9), makeBet('Edmonton vs Vancouver', 'EDM', 'Edmonton to win', 45, 1.65)] }),
  () => ({ kind: 'spin', user: 'Marc88', ago: 'just now', amount: 150, bets: [] }),
];
const STEPS = ['goal', 'bet', 'goal', 'win', 'bet', 'goal', 'lose'];

function CountUp({ to }) {
  const [shown, setShown] = useState(0);
  useEffect(() => {
    const start = performance.now();
    let frame;
    const step = (now) => {
      const t = Math.min((now - start) / 1400, 1);
      setShown(to * (1 - (1 - t) ** 3));
      if (t < 1) frame = requestAnimationFrame(step);
    };
    frame = requestAnimationFrame(step);
    return () => cancelAnimationFrame(frame);
  }, [to]);
  return money(shown);
}

function Row({ bet, game, moment, onLike }) {
  const clock = game && `${Math.floor(game.secs / 60)}:${String(game.secs % 60).padStart(2, '0')}`;
  return (
    <BetLike className={`fa-row${moment ? ` ${moment}` : ''}${bet.result ? ` ${bet.result}` : ''}`} liked={bet.liked} count={bet.likes} onToggle={() => onLike(bet.id)}>
      <img className="fa-logo" src={logo(bet.team)} alt="" />
      <div className="fa-main">
        <b>{bet.pick}</b>
        {game ? (
          <span className="fa-score" key={`${game.as}-${game.hs}`}>
            {game.away} {game.as} – {game.hs} {game.home}
            <small><i />{game.period} {clock}</small>
          </span>
        ) : <span className="fa-desc">{bet.game}</span>}
      </div>
      <div className="fa-money">
        {bet.result ? <em>{bet.result === 'won' ? 'WON' : 'LOST'}</em> : <b>{money(bet.stake)}</b>}
        <span>{bet.result === 'won' ? `+${money(bet.stake * bet.odds)}` : `@ ${bet.odds.toFixed(2)}`}</span>
      </div>
      {bet.floats.map((f) => <span key={f} className="fa-float" aria-hidden="true">🔥</span>)}

    </BetLike>
  );
}

// the flame for posts that aren't bet rows
function Card({ className, style, children }) {
  const [likes, setLikes] = useState(0);
  const [liked, setLiked] = useState(false);
  return <BetLike className={`fa-card ${className}`} style={style} liked={liked} count={likes} onToggle={() => { setLikes(likes + (liked ? -1 : 1)); setLiked(!liked); }}>{children}</BetLike>;
}

function BetPost({ post, games, goal, onLike }) {
  const [open, setOpen] = useState(false);
  const total = post.bets.reduce((sum, b) => sum + b.stake, 0);
  const many = post.bets.length > 1;
  return (
    <div className={`feed-post${post.fresh ? ' fa-land' : ''}`}>
      <div className="feed-top">
        <TeamAvatar team={null} name={post.user} size={40} />
        <div className="feed-top-text">
          <p><b>{post.user}</b> {many ? <>placed <b>{post.bets.length} bets</b> for <b>{money(total)}</b></> : <>bet <b>{money(total)}</b></>}{total >= 500 && <span className="feed-big-mark">BIG BET</span>}</p>
          <time>{post.fresh ? 'just now' : post.ago}</time>
        </div>
      </div>
      <div className="feed-rows">
        {(open ? post.bets : post.bets.slice(0, ROWS_SHOWN)).map((b) => {
          const hit = goal && goal.game === b.game ? (goal.team === b.team ? 'good' : 'bad') : null;
          return <Row key={b.id} bet={b} game={games[b.game]} moment={hit} onLike={onLike} />;
        })}
      </div>
      {post.bets.length > ROWS_SHOWN && (
        <button type="button" className="feed-more" onClick={() => setOpen((o) => !o)}>{open ? 'Show less' : `Show ${post.bets.length - ROWS_SHOWN} more`}</button>
      )}
    </div>
  );
}

const WHO = (post, verb) => <span className="fa-who"><TeamAvatar team={null} name={post.user} size={24} /><b>{post.user}</b> {verb} · {post.ago}</span>;

function Post({ post, games, goal, onLike }) {
  switch (post.kind) {
    case 'boost':
      return <div className="fa-boost"><strong>Boost Weekend</strong><span>Odds ×2 until Sunday at midnight</span></div>;
    case 'bigwin':
      return (
        <Card className="fa-bigwin" style={{ '--team': TEAMS[post.team].color }}>
          {WHO(post, 'won')}
          <strong>{money(post.amount)}</strong>
          <p>{post.pick}<small>{post.how}</small></p>
          <img src={logo(post.team)} alt="" />
        </Card>
      );
    case 'win':
      return (
        <Card className="fa-smallwin">
          {WHO(post, 'won')}
          <strong>{money(post.amount)}</strong>
          <p>{post.pick}<small>{post.how}</small></p>
          <img src={logo(post.team)} alt="" />
        </Card>
      );
    case 'predict':
      return (
        <Card className="fa-predict">
          {WHO(post, 'won Predict the Night')}
          <strong>{money(post.amount)}</strong>
          <div className="fa-predict-logos">{['VGK', 'FLA', 'WSH', 'BOS'].map((a) => <i key={a}><img src={logo(a)} alt="" /></i>)}</div>
        </Card>
      );
    case 'spin':
      return (
        <Card className="fa-spin">
          <img src="/slot/stanley-cup.png" alt="" />
          <div>{WHO(post, 'hit The Spin')}<strong>{money(post.amount)}</strong></div>
        </Card>
      );
    case 'jackpot':
      return (
        <Card className="fa-jackpot">
          {WHO(post, 'took the monthly jackpot')}
          <strong>{money(post.amount)}</strong>
          <p>1st place</p>
        </Card>
      );
    case 'lost':
      return <Card className="fa-lost"><img src={logo(post.team)} alt="" /><p><b>{post.user}</b> lost <b>{money(post.amount)}</b> on {post.pick}</p><time>{post.ago}</time></Card>;
    case 'rail':
      return (
        <div className="fa-rail">
          <h3>Biggest wins · 24 h</h3>
          <div>
            {[['Chungussifu', 4500], ['CL34RY', 2500], ['DI4N3', 441], ['DI4N3', 300], ['Marc88', 125]].map(([n, a], i) => (
              <span key={i}><em>{i + 1}</em><TeamAvatar team={null} name={n} size={28} /><small>{n}</small><b>{money(a)}</b></span>
            ))}
          </div>
        </div>
      );
    default:
      return <BetPost post={post} games={games} goal={goal} onLike={onLike} />;
  }
}

export default function FeedAlive() {
  const [posts, setPosts] = useState(startPosts);
  const [games, setGames] = useState(START_GAMES);
  const [goal, setGoal] = useState(null);
  const [win, setWin] = useState(null);
  const postsNow = useRef(posts);
  postsNow.current = posts;

  const allBets = () => postsNow.current.flatMap((p) => p.bets.map((b) => ({ ...b, user: p.user })));
  const open = () => allBets().filter((b) => !b.result);
  const change = (id, fn) => setPosts((list) => list.map((p) => ({ ...p, bets: p.bets.map((b) => (b.id === id ? fn(b) : b)) })));

  const like = (id) => change(id, (b) => ({ ...b, liked: !b.liked, likes: b.likes + (b.liked ? -1 : 1) }));

  useEffect(() => {
    const timers = new Set();
    const later = (fn, ms) => { const t = setTimeout(() => { timers.delete(t); fn(); }, ms); timers.add(t); };

    const clock = setInterval(() => setGames((all) => Object.fromEntries(Object.entries(all).map(([k, g]) => [k, { ...g, secs: g.secs > 1 ? g.secs - 1 : 1200 }]))), 1000);

    const chatter = setInterval(() => {
      const b = pickOne(open());
      if (!b) return;
      const floatId = nextId++;
      change(b.id, (x) => ({ ...x, likes: x.likes + 1, floats: [...x.floats, floatId] }));
      later(() => change(b.id, (x) => ({ ...x, floats: x.floats.filter((f) => f !== floatId) })), 1400);
    }, CHATTER_MS);

    let betsDropped = 0;
    const settle = (result) => {
      const b = pickOne(open().filter((x) => START_GAMES[x.game] && (x.user !== 'CL34RY' || result === 'won')));
      if (!b) return;
      change(b.id, (x) => ({ ...x, result }));
      if (result === 'won') {
        setWin({ key: b.id, name: b.user, amount: b.stake * b.odds, pick: b.pick, team: b.team });
        later(() => setWin(null), WIN_MS);
      }
    };
    const actions = {
      goal: () => {
        const id = pickOne(Object.keys(START_GAMES));
        const side = Math.random() < 0.5 ? 'away' : 'home';
        setGames((all) => {
          const g = all[id];
          return { ...all, [id]: side === 'away' ? { ...g, as: g.as + 1 } : { ...g, hs: g.hs + 1 } };
        });
        setGoal((prev) => ({ key: (prev?.key || 0) + 1, game: id, team: START_GAMES[id][side] }));
        later(() => setGoal(null), GOAL_MS);
      },
      bet: () => {
        const made = { ...NEW_POSTS[(betsDropped++) % NEW_POSTS.length](), id: nextId++, fresh: true };
        setPosts((list) => {
          const fresh = list.filter((p) => p.fresh);
          const gone = fresh.length >= NEW_KEPT ? fresh[fresh.length - 1].id : null;
          return [made, ...list.filter((p) => p.id !== gone)];
        });
      },
      win: () => settle('won'),
      lose: () => settle('lost'),
    };
    let step = 0;
    const run = setInterval(() => { actions[STEPS[step % STEPS.length]](); step += 1; }, STEP_MS);

    return () => { clearInterval(clock); clearInterval(chatter); clearInterval(run); timers.forEach(clearTimeout); };
    // the made-up activity runs once, for as long as the page is open
  }, []);

  return (
    <div className="fa-page">
      <style>{CSS}</style>
      <div className="feed-header">
        <h2>Feed</h2>
        <span className="feed-live"><i />LIVE</span>
      </div>

      {goal && (
        <div className="fa-goal" key={goal.key} style={{ '--team': TEAMS[goal.team].color }}>
          <img src={logo(goal.team)} alt="" />
          <div><strong>GOAL!</strong><span>{TEAMS[goal.team].name} · {games[goal.game].away} {games[goal.game].as} – {games[goal.game].hs} {games[goal.game].home}</span></div>
        </div>
      )}

      <div className="feed-list">
        {win && (
          <div className="fa-grow" key={win.key}>
            <div className="fa-win" style={{ '--team': TEAMS[win.team].color }}>
              {Array.from({ length: 22 }, (_, i) => <i key={i} style={{ '--x': `${(i * 37) % 100}%`, '--d': `${(i % 7) * 70}ms`, '--c': ['#fbbf24', '#fff', '#22c55e', '#f97316'][i % 4] }} />)}
              <div className="fa-win-text">
                <span>{win.name} just hit</span>
                <strong><CountUp to={win.amount} /></strong>
                <span>{win.pick}</span>
              </div>
              <img src={logo(win.team)} alt="" />
            </div>
          </div>
        )}
        {posts.map((post) => (
          <div key={post.id} className={post.fresh ? 'fa-grow' : undefined}>
            <Post post={post} games={games} goal={goal} onLike={like} />
          </div>
        ))}
      </div>

    </div>
  );
}

const CSS = `
.fa-page { position: relative; max-width: 640px; margin: 0 auto; padding: 16px; }
.fa-grow { display: grid; animation: fa-grow 0.55s cubic-bezier(0.3, 0.8, 0.4, 1) both; }
.fa-grow > * { min-height: 0; overflow: hidden; }
.fa-grow > .feed-post { overflow: visible; }
@keyframes fa-grow { from { grid-template-rows: 0fr; opacity: 0; } to { grid-template-rows: 1fr; opacity: 1; } }
.fa-land { animation: fa-land 0.7s cubic-bezier(0.37, 0, 0.63, 1) both; transform-origin: 50% 0; }
@keyframes fa-land { 0% { transform: translateY(-26px) scale(0.96); } 55% { transform: translateY(0) scale(1.012, 0.985); } 80% { transform: scale(0.997, 1.006); } 100% { transform: none; } }

.fa-row { position: relative; display: grid; grid-template-columns: 30px minmax(0, 1fr) auto 44px; align-items: center; gap: 4px 10px; padding: 8px 0; border-top: 1px solid var(--fl-line); border-radius: 6px; }
.fa-row > .bet-like { grid-column: 4; grid-row: 1; justify-self: center; margin: 0; padding: 0; }
.fa-logo { width: 30px; height: 30px; object-fit: contain; }
.fa-main { min-width: 0; display: flex; flex-direction: column; line-height: 1.25; }
.fa-main b { font-size: 14px; }
.fa-score { display: flex; flex-wrap: wrap; align-items: center; gap: 2px 8px; font-family: var(--fl-display); font-size: 15px; font-weight: 800; }
.fa-score small { display: inline-flex; align-items: center; gap: 4px; color: #dc2626; font-family: var(--fl-font); font-size: 11px; font-weight: 700; }
.fa-score small i { width: 6px; height: 6px; border-radius: 50%; background: #dc2626; animation: feed-live 1.6s ease-in-out infinite; }
.fa-desc { color: var(--text-muted); font-size: 12px; }
.fa-money { display: flex; flex-direction: column; align-items: flex-end; line-height: 1.25; font-variant-numeric: tabular-nums; }
.fa-money b, .fa-money em { font-family: var(--fl-display); font-size: 17px; font-style: normal; font-weight: 800; }
.fa-money span { color: var(--text-muted); font-size: 12px; }
.fa-row.won .fa-money em, .fa-row.won .fa-money span { color: var(--win, #16a34a); }
.fa-row.lost .fa-money em { color: #dc2626; }
.fa-row.lost { animation: fa-shake 0.5s ease-in-out; }
.fa-row.lost .fa-logo, .fa-row.lost .fa-main { opacity: 0.5; }
@keyframes fa-shake { 20% { transform: translateX(-5px); } 45% { transform: translateX(4px); } 70% { transform: translateX(-2px); } }

/* a goal: everyone on that game feels it at once */
.fa-row.good { animation: fa-good 2.2s ease-out; }
.fa-row.bad { animation: fa-bad 2.2s ease-out; }
.fa-row.good .fa-score, .fa-row.bad .fa-score { animation: fa-pop 0.5s cubic-bezier(0.3, 1.6, 0.5, 1); transform-origin: 0 50%; }
@keyframes fa-good { 0% { background: rgba(22, 163, 74, 0.34); } 100% { background: transparent; } }
@keyframes fa-bad { 0% { background: rgba(220, 38, 38, 0.26); } 100% { background: transparent; } }
@keyframes fa-pop { 0% { transform: scale(1); } 40% { transform: scale(1.22); } 100% { transform: scale(1); } }
.fa-goal { position: fixed; top: 8px; left: 16px; right: 16px; max-width: 608px; margin: 0 auto; z-index: 20; display: flex; align-items: center; gap: 12px; padding: 10px 14px; border-radius: var(--fl-radius-lg); background: var(--team); color: #fff; box-shadow: var(--fl-shadow); animation: fa-goal 2.6s cubic-bezier(0.3, 0.8, 0.4, 1) both; }
.fa-goal img { width: 46px; height: 46px; padding: 6px; border-radius: 50%; background: #fff; object-fit: contain; }
.fa-goal strong { display: block; font-family: var(--fl-display); font-size: 30px; font-weight: 800; line-height: 1; }
.fa-goal span { font-size: 13px; }
@keyframes fa-goal { 0% { transform: translateY(-20px) scale(0.92); opacity: 0; } 12% { transform: translateY(0) scale(1.03); opacity: 1; } 20% { transform: none; } 88% { transform: none; opacity: 1; } 100% { transform: translateY(-14px); opacity: 0; } }

.fa-float { position: absolute; right: 12px; top: 8px; z-index: 3; font-size: 18px; pointer-events: none; animation: fa-float 1.4s ease-out both; }
@keyframes fa-float { 0% { transform: translateY(0) scale(0.6); opacity: 0; } 15% { opacity: 1; } 100% { transform: translateY(-70px) translateX(-12px) scale(1.25); opacity: 0; } }

/* a win takes over the top of the feed */
.fa-win { position: relative; display: flex; align-items: center; justify-content: space-between; gap: 12px; padding: 18px; border-radius: var(--fl-radius-lg); background: var(--team); color: #fff; animation: fa-land 0.7s cubic-bezier(0.37, 0, 0.63, 1) both; }
.fa-win-text { position: relative; z-index: 1; min-width: 0; display: flex; flex-direction: column; font-size: 13px; }
.fa-win strong { font-family: var(--fl-display); font-size: 54px; font-weight: 800; line-height: 1.05; font-variant-numeric: tabular-nums; }
.fa-win > img { flex: none; width: 76px; height: 76px; padding: 10px; border-radius: 50%; background: #fff; object-fit: contain; }
.fa-win > i { position: absolute; top: -10px; left: var(--x); width: 7px; height: 11px; background: var(--c); animation: fa-confetti 1.7s ease-in var(--d) both; }
@keyframes fa-confetti { from { transform: translateY(0) rotate(0); opacity: 1; } to { transform: translateY(190px) rotate(540deg); opacity: 0; } }

/* every kind of moment has its own shape */
.fa-card { position: relative; overflow: hidden; border-radius: var(--fl-radius-lg); }
.fa-card > .bet-like { position: absolute; top: 10px; right: 10px; z-index: 2; margin: 0; padding: 2px; }
.fa-who { position: relative; z-index: 1; display: flex; align-items: center; gap: 7px; padding-right: 44px; font-size: 13px; }
.fa-card strong { position: relative; z-index: 1; display: block; font-family: var(--fl-display); font-weight: 800; line-height: 1.05; font-variant-numeric: tabular-nums; }
.fa-card p { position: relative; z-index: 1; margin: 0; font-size: 14px; font-weight: 700; }
.fa-card p small { display: block; font-size: 12px; font-weight: 400; opacity: 0.8; }

.fa-boost { display: flex; flex-wrap: wrap; align-items: baseline; gap: 2px 10px; padding: 10px 14px; border-radius: var(--fl-radius); background: var(--accent); color: #fff; font-size: 13px; }
.fa-boost strong { font-family: var(--fl-display); font-size: 20px; font-weight: 800; text-transform: uppercase; }

.fa-bigwin { padding: 16px; background: var(--team); color: #fff; }
.fa-bigwin > .bet-like, .fa-predict > .bet-like, .fa-spin > .bet-like, .fa-jackpot > .bet-like { color: #fff; }
.fa-bigwin strong { margin-top: 12px; font-size: 60px; }
.fa-bigwin > img { position: absolute; right: -24px; bottom: -24px; width: 150px; height: 150px; padding: 24px; border-radius: 50%; background: #fff; object-fit: contain; }

.fa-smallwin { padding: 12px 14px; border: 1px solid var(--fl-line); background: var(--fl-surface, #fff); box-shadow: var(--fl-shadow-sm); }
.fa-smallwin strong { margin-top: 8px; color: var(--win, #16a34a); font-size: 34px; }
.fa-smallwin > img { position: absolute; right: 12px; bottom: -10px; width: 96px; height: 96px; object-fit: contain; opacity: 0.16; }

.fa-predict { padding: 14px; background: #d97706; color: #fff; }
.fa-predict strong { margin-top: 8px; font-size: 42px; }
.fa-predict-logos { display: flex; gap: 6px; margin-top: 10px; }
.fa-predict-logos i { width: 40px; height: 40px; padding: 5px; border-radius: 50%; background: #fff; }
.fa-predict-logos img { display: block; width: 100%; height: 100%; object-fit: contain; }

.fa-spin { display: flex; align-items: center; gap: 14px; padding: 12px 14px; background: #111827; color: #fff; }
.fa-spin > img { width: 56px; height: 72px; object-fit: contain; }
.fa-spin > div { flex: 1; min-width: 0; }
.fa-spin strong { margin-top: 4px; color: #fbbf24; font-size: 38px; }

.fa-jackpot { padding: 22px 16px; background: #fbbf24; color: #111827; text-align: center; }
.fa-jackpot > .bet-like { color: #111827; }
.fa-jackpot .fa-who { justify-content: center; padding: 0 30px; }
.fa-jackpot strong { margin: 8px 0 2px; font-size: 68px; }

.fa-lost { display: flex; align-items: center; gap: 8px; padding: 7px 44px 7px 12px; border-radius: 999px; background: rgba(220, 38, 38, 0.08); }
.fa-lost > img { width: 22px; height: 22px; object-fit: contain; }
.fa-lost p { flex: 1; min-width: 0; font-size: 13px; font-weight: 400; }
.fa-lost time { color: var(--text-muted); font-size: 11px; }
.fa-lost > .bet-like { top: 3px; }

.fa-rail h3 { margin: 4px 0 8px; font-family: var(--fl-display); font-size: 18px; font-weight: 800; text-transform: uppercase; }
.fa-rail > div { display: flex; gap: 8px; overflow-x: auto; padding-bottom: 4px; scrollbar-width: none; }
.fa-rail > div > span { position: relative; flex: none; width: 118px; display: flex; flex-direction: column; align-items: center; gap: 3px; padding: 10px 8px; border: 1px solid var(--fl-line); border-radius: var(--fl-radius); background: var(--fl-surface, #fff); }
.fa-rail em { position: absolute; top: 6px; left: 9px; color: var(--text-muted); font-family: var(--fl-display); font-size: 15px; font-style: normal; font-weight: 800; }
.fa-rail small { max-width: 100%; color: var(--text-muted); font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.fa-rail b { color: var(--win, #16a34a); font-family: var(--fl-display); font-size: 19px; font-weight: 800; }

@media (max-width: 480px) {
  .fa-bigwin strong { font-size: 48px; }
  .fa-bigwin > img { width: 120px; height: 120px; padding: 20px; }
  .fa-jackpot strong { font-size: 56px; }
  .fa-win strong { font-size: 42px; }
  .fa-win > img { width: 58px; height: 58px; }
}
`;
